import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    // ******************** localStorage 版本********************
    state: {
        // 存储token
        userToken: localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '',
        is_auth: localStorage.getItem('is_auth') ? localStorage.getItem('is_auth') : '',
        abc: localStorage.getItem('abc') ? localStorage.getItem('abc') : '',
        // 用户名-手机号
        userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
        // 省份
        provinceName: localStorage.getItem('provinceName') ? localStorage.getItem('provinceName') : '',
        // 省份id
        provinceId: localStorage.getItem('provinceId') ? localStorage.getItem('provinceId') : '',
        // 城市
        cityName: localStorage.getItem('cityName') ? localStorage.getItem('cityName') : '',
        // 城市id
        cityId: localStorage.getItem('cityId') ? localStorage.getItem('cityId') : '',
        // 当前省份下的城市列表
        provinceCitys: localStorage.getItem('provinceCitys') ? JSON.parse(localStorage.getItem('provinceCitys')) : '',
        // 首页本地车队
        localTeam: localStorage.getItem('localTeam') ? JSON.parse(localStorage.getItem('localTeam')) : '',
        // 首页本地车队
        localCd: '',
        // 包车列表
        teamList: localStorage.getItem('teamList') ? localStorage.getItem('teamList') : '',
        // 包车列表
        cdList: [],
        articleObj: localStorage.getItem('articleObj') ? localStorage.getItem('articleObj') : '',

        // 精选车队
        jxList: [],
        userTimUid: localStorage.getItem('userTimUid') ? localStorage.getItem('userTimUid') : '',

        userIp: '',
        // 成人数
        crNumber: localStorage.getItem('crNumber') ? localStorage.getItem('crNumber') : 1,
        // 儿童数
        etNumber: localStorage.getItem('etNumber') ? localStorage.getItem('etNumber') : 0,
    },
    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin(state, user) {
            state.userToken = user.userToken;
            localStorage.setItem('userToken', user.userToken);
        },
        checkAuth(state, user) {
            state.is_auth = user.is_auth;
            localStorage.setItem('is_auth', user.is_auth);
        },

        saveUser(state, user) {
            state.userName = user.userName;
            localStorage.setItem('userName', user.userName);
        },

        saveTimUid(state,user) {
            state.userTimUid = user.userTimUid;
            localStorage.setItem('userTimUid', user.userTimUid);
        },

        // 保存省份名称
        saveProvinceName(state, user){
            state.provinceName = user.provinceName;
            localStorage.setItem('provinceName', user.provinceName);
        },

        // 保存省份id
        saveProvinceId(state, user){
            state.provinceId = user.provinceId;
            localStorage.setItem('provinceId', user.provinceId);
        },

        // 保存城市名称
        saveCityName(state, user){
            state.cityName = user.cityName;
            localStorage.setItem('cityName', user.cityName);
        },

        // 保存城市id
        saveCity(state, user) {
            state.cityId = user.cityId;
            localStorage.setItem('cityId', user.cityId);
        },

        // 保存省份下的城市列表数组
        saveProvinceCitys(state, user){
            state.provinceCitys = user;
            localStorage.setItem('provinceCitys', JSON.stringify(user));
        },

        // 包车列表
        saveTeamList(state, user){
            state.teamList = JSON.stringify(user.saveTeamList);
            localStorage.setItem('teamList', JSON.stringify(user.saveTeamList));
        },

        // 包车列表
        saveCdList(state, user){
            state.cdList = user.saveCdList;
            // state.cdList = JSON.stringify(user.saveCdList);
            // localStorage.setItem('cdList', JSON.stringify(user.saveCdList));
        },

        saveArticleId(state, user){
            state.articleType = user.articleType;
            state.articleId = user.articleId;
            localStorage.setItem('saveArticleId', user.saveArticleId);
        },

        // 首页获取本地车队
        saveLocalTeam(state,user){
            state.localTeam = user.localTeam;
            // localStorage.setItem('localTeam',JSON.stringify(user.localTeam));
        },

        saveLocalCd(state, user){
            state.localCd = user.localCd;
        },

        saveJxList(state,user){
            state.jxList = user.jxList;
        },

        saveUserIp(state,user){
            state.userIp = user;
        },

        // 保存成人人数
        saveCrNumber(state,user){
            state.crNumber = user.crNumber;
            // localStorage.setItem('crNumber',JSON.stringify(user.crNumber));
        },

        // 保存儿童人数
        saveEtNumber(state,user){
            state.etNumber = user.etNumber;
            // localStorage.setItem('etNumber',JSON.stringify(user.etNumber));
        },

        // 保存儿童人数
        saveStartTime(state,user){
            // state.etNumber = user.etNumber;
            // localStorage.setItem('etNumber',JSON.stringify(user.etNumber));
        },

        // 保存儿童人数
        saveEndTime(state,user){
            // state.etNumber = user.etNumber;
            // localStorage.setItem('etNumber',JSON.stringify(user.etNumber));
        },

        // 测试
        abc(state, user) {
            //存入localStorage方法
            //存入的参数
            const obj = {
                name: '', // 存入的名字
                value: '', // 存入的值
                expires: "", // 过期时间
                startTime: new Date().getTime() //存入的时间
            }
            const options = {};// 将obj 和传进来的params 合并 放到options里面 实现js中浅拷贝
            Object.assign(options, obj, user);
            // 判断用户是否设置了过期时间
            if (options.expires) {
                // 以options.name为key, options为值放进去
                state.abc = options;
                localStorage.setItem(options.name, JSON.stringify(options));
            } else {
                // 如果 options.expires 没有设置的话， 就判断一下value的类型
                // 注意 我们的localStorage 只能存储字符串 像是数组和对象要转换下
                let type = Object.prototype.toString.call(options.value);
                if (type == '[object Object]' || type == '[object Array]') {
                    options.value = JSON.stringify(options.value);
                }
                state.abc = options;
                localStorage.setItem(options.name, options.value);
            }
        }
    },

    getters: {
        getuserToken(state){
            return state.userToken;
        },
        getsaveLocalTeam(state){
            return state.localTeam;
        },
        getsaveLocalCd(state){
            return state.localCd;
        },
        getcdList(state){
            return state.cdList;
        },
        getprovinceId(state){
            return state.provinceId;
        },
        getcityId(state){
            return state.cityId;
        },
        getprovinceName(state){
            return state.provinceName;
        },
        getcityName(state) {
            return state.cityName;
        },

        getprovinceCitys(state){
            return state.provinceCitys;
        },

        getjxList(state){
            return state.jxList;
        },

        getuserTimUid(state){
          return state.userTimUid;
        },

        getuserIp(state){
            return state.userIp;
        },

        getCrNumber(state){
            return state.crNumber;
        },

        getEtNumber(state){
            return state.etNumber;
        }
    }

    // ******************** sessionStorage 版本********************

    /*state: {
        // 存储token
        Authorization: sessionStorage.getItem('Authorization') ? sessionStorage.getItem('Authorization') : '',
        is_auth: sessionStorage.getItem('is_auth') ? sessionStorage.getItem('is_auth') : ''
    },
    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin(state, user) {
            state.Authorization = user.Authorization;
            sessionStorage.setItem('Authorization', user.Authorization);
        },
        checkAuth(state, user){
            state.is_auth = user.is_auth;
            sessionStorage.setItem('is_auth', user.is_auth);
        }
    }*/
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js